import { DtStandard } from '@ow/ditto-core'

const { validation, transformer, filterSpec } = DtStandard
export { default as Render } from './render'
export { default as Filter } from './filter'

// export { default as validation } from './validation'
// // export { default as Filter } from './render'
// export { filterSpec } from './config'
// export { default as transformer } from './transformer'
export { validation, transformer, filterSpec }
